<script>
import DurationInput from './duration-input';

export default {
  name: 'ParametreInput',
  components: {
    DurationInput
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    type: {
      type: String,
      required: true
    },
    format: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    inner_value: null
  }),
  watch: {
    value () {
      this.inner_value = this.value;
    },
    inner_value () {
      this.updateValue();
    }
  },
  created () {
    this.inner_value = this.value;
  },
  methods: {
    updateValue () {
      if (this.inner_value !== this.value) {
        this.$emit('input', this.inner_value);
      }
    }
  }
};
</script>

<template>
  <div>
    <NumberField
      v-if="type === 'Integer'"
      v-model="inner_value"
      step="1"
      :disabled="disabled"
      :rules="errors"
    />
    <NumberField
      v-else-if="type === 'Float'"
      v-model="inner_value"
      :disabled="disabled"
      :rules="errors"
    />
    <DurationInput
      v-else-if="type === 'periode'"
      v-model="inner_value"
      :format="format"
      :disabled="disabled"
      :rules="errors"
    />
    <v-text-field
      v-else
      v-model="inner_value"
      :disabled="disabled"
      :rules="errors"
    />
  </div>
</template>
